import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>About NIARJS</h3>
          <p>
            Napier Indian Advanced Research Journal of Sciences is a prestigious national multidisciplinary peer-reviewed research journal established in 2008.
          </p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><button onClick={() => document.getElementById('home').scrollIntoView({ behavior: 'smooth' })}>Home</button></li>
            <li><button onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}>About</button></li>
            <li><button onClick={() => document.getElementById('editorial-board').scrollIntoView({ behavior: 'smooth' })}>Editorial Board</button></li>
            <li><button onClick={() => document.getElementById('officers').scrollIntoView({ behavior: 'smooth' })}>Officers</button></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact Info</h3>
          <p>Society of the Advanced Research Sciences</p>
          <p>Arrah (Bihar), India</p>
          <p>ISSN: 0975-1726</p>
          <a href="http://www.napieriarjournals.in" target="_blank" rel="noopener noreferrer">
            www.napieriarjournals.in
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 Napier Indian Advanced Research Journal of Sciences. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
